<template>
  <div class="login-wrap" :class="mark">
    <header class="flex-center header-warpper">
      <div class="flex-center contaner">
        <div class="flex-center logo-box">
          <div class="flex-center logo-box_img">
            <img
              src="../../../assets/images/gopay/gopay-logo.svg"
              style="width: 80px; height: 48px"
            />
          </div>
        </div>
        <div class="flex-center right-menu">
          <!-- {{$t('login.support')}} -->
          <select-lang />
        </div>
      </div>
    </header>
    <div class="contaner tent-contaner">
      <div class="label">{{ $t('login.gopaylabel') }}</div>
      <el-form
        class="login-form"
        label-position="top"
        label-width="80px"
        :model="formdata"
        :rules="rules"
        ref="form"
      >
        <div style="margin-bottom: 5%">
          <h2>{{ $t('login.rules.form.Login') }}</h2>
          <el-form-item prop="username">
            <el-input
              v-model.trim="formdata.username"
              prefix-icon="icon-user"
              :placeholder="$t('login.rules.form.UserName')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              prefix-icon="icon-more-outline"
              v-model="formdata.password"
              show-password
              :placeholder="$t('login.rules.form.Password')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-input
              v-model.trim="formdata.code"
              prefix-icon="icon-chat-dot-round"
              :placeholder="$t('login.rules.form.verification')"
            ></el-input>
          </el-form-item>
          <!--<img :src="captchaImg" alt="" @click="changeed()" style="margin-left: 45%" />-->
        </div>
        <el-button @click="handleLogin()" class="login-btn">{{
          $t('login.rules.form.btnlogin')
        }}</el-button>
        <!-- <p class="forgotText">{{$t('login.rules.form.Forgotpassword')}}</p> -->
      </el-form>
    </div>
  </div>
</template>

<script>
import selectLang from '@/components/cuscom/select-lang/lang-go';
import { checkPass } from '@/utils/validate';
export default {
  components: { selectLang },
  data() {
    return {
      mark: 'go',
      loading: false,
      formdata: {
        username: '',
        password: '',
        code: ''
      },
      captchaImg: '' //图片路径
    };
  },

  created() {
    this.mark = localStorage.getItem('login_info');

    if (process.env.NODE_ENV === 'development') {
      this.formdata.username = 'testzat';
      this.formdata.password = '123456';
    }
    // this.Render();
    this.rules = {
      username: [
        {
          required: true,
          message: this.$t('login.rules.username'),
          trigger: 'blur'
        }
      ],
      code: [
        {
          required: true,
          message: this.$t('login.rules.code'),
          trigger: 'blur'
        }
      ],
      password: [
        {
          required: true,
          message: this.$t('login.rules.password'),
          trigger: 'blur'
        },
        {
          validator: (rule, value, cb) => {
            if (!checkPass(value)) {
              cb(new Error(this.$t('passwd.rules.newPasswd.format')));
            } else {
              cb();
            }
          },
          trigger: 'blur'
        }
      ]
    };
  },
  mounted() {
    this.init();
  },
  destroyed() {
    document.removeEventListener('keyup', (e) => {
      if (e && e.keyCode == 13) {
        this.handleLogin();
      }
    });
  },
  methods: {
    init() {
      document.addEventListener('keyup', (e) => {
        if (e && e.keyCode == 13) {
          this.handleLogin();
        }
      });
    },
    // 获取验证码
    async Render() {
      this.loading = true;
      let res = await this.$http.get('/token/render', {
        responseType: 'blob'
      });
      console.log(res);
      this.loading = false;
      this.captchaImg = window.URL.createObjectURL(res.data);
    },
    // 切换验证码
    changeed() {
      this.Render();
    },
    loginSuccess(res) {
      this.$message.success(res.msg);
      this.$router.push({
        // name: 'home'
        path: res.data.menuTree[0].menuUrl
      });
    },
    async handleLogin() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const params = {
            kaptchaCode: this.formdata.code,
            password: this.formdata.password,
            userName: this.formdata.username
          };
          const data = await this.$store.dispatch('handleLogin', params);
          if (data.code === 200) {
            this.loginSuccess(data);
          } else {
            // //刷新验证码
            // this.Render();
            this.formdata.code = '';
            this.$message.error(data.msg || 'Network error!');
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.right-menu {
  gap: 8px;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #ffffff;
}
.forgotText {
  font-family: FZSongHei-B07S;
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  color: #249451;
  margin-bottom: 0;
}

.login-wrap {
  height: 100vh;
  background: url('../../../assets/images/gopay/gopay-3-pc-bg.png') no-repeat center/cover;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  .header-warpper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 88px;
    background: transparent;
    .contaner {
      width: 100%;
      height: 100%;
      justify-content: space-between;
      padding: 0 100px;
      box-sizing: border-box;
      .system-text {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 48px;
        width: 84px;
        margin-left: 40px;
        box-shadow: 0px -2px 2px 0px #ffffff, /*上边阴影 */ -2px 0px 2px 0px #ffffff,
          /*左边阴影*/ 0px 2px 2px 0px #0000001f, /*下边阴影*/ 2px 0px 2px 0px #0000001f; /*右边阴影*/
      }
    }
  }
  .tent-contaner {
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    width: 100%;
  }
  .label {
    width: 600px;
    color: #ffffff;
    // text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    font-family: FZSongHei-B07;
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 44.8px;
    letter-spacing: 3px;
    //flex: 1;
    //margin-right: 100px;
  }
}
.login-wrap {
  &.go {
    .header-warpper {
      background: #ffffff;
    }
    .right-menu {
      color: #2f322f;
    }
    /deep/ .el-dropdown-link {
      color: #2f322f;
    }
    .label {
      color: #10853f;
    }
  }
  &.Gopay {
    background: url('../../../assets/images/gopay/gopay-2-pc-bg.png') no-repeat center/cover;
  }
  &.gopay {
    background: url('../../../assets/images/gopay/gopay-3-pc-bg.png') no-repeat center/cover;
  }
}
.flex-center {
  display: flex;
  align-items: center;
}
.login-wrap .login-form {
  width: 400px;
  background-color: #ffffff;
  border-radius: 24px;
  padding: 30px;
  box-sizing: border-box;
  box-shadow: 0px 8px 16px 0px #1c2e081f;
}

.login-wrap .login-btn {
  width: 100%;
  color: #ffffff;
  border: none;
  border-radius: 12px;
  background: #0fa94c;
  box-shadow: 0px 8px 16px 0px #1c2e081f;
  padding: 17px;
}
h2 {
  font-family: Montserrat;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  text-align: center;
  margin-top: 0;
}

/deep/ .el-input__prefix {
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/ .el-input--prefix .el-input__inner {
  padding-left: 64px;
}
/deep/ .icon-user,
/deep/ .icon-more-outline,
/deep/ .icon-chat-dot-round {
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/ .el-input__icon {
  width: 45px;
  height: 56px;
}
/deep/ .icon-user {
  background: url('../../../assets/images/gopay/user.png') no-repeat center;
  background-size: 40px 40px;
}
/deep/ .icon-more-outline {
  background: url('../../../assets/images/gopay/password.png') no-repeat center;
  background-size: 40px 40px;
}
/deep/ .icon-chat-dot-round {
  background: url('../../../assets/images/gopay/code.png') no-repeat center;
  background-size: 40px 40px;
}
/deep/ .el-input__inner {
  background-color: #ffffff;
  border: none;
  height: 56px;
  line-height: 56px;
  border: 1px solid #91e4b2;
  border-radius: 12px;
}

@media screen and (max-width: 480px) {
  h2 {
    font-size: 18px;
    line-height: 28px;
  }
  .el-form-item {
    margin-bottom: 16px;
  }
  .forgotText {
    margin-top: 16px;
    font-size: 16px;
    font-weight: 500;
  }
  .login-wrap {
    background: url('../../../assets/images/gopay/gopay-3-mobile-bg.png') no-repeat center/cover;
    .header-warpper {
      height: 56px;
      .contaner {
        padding: 0 0 0 16px;
      }
    }
    .tent-contaner {
      margin-top: 1.6rem;
      flex-direction: column;
      gap: 0.8rem;
    }
    .label {
      width: 92%;
      margin: 0 4%;
      font-size: 24px;
      font-weight: 400;
      line-height: 32px;
      text-align: center;
      letter-spacing: 2.1px;
    }
    .login-form {
      width: 92%;
      padding: 24px 16px;
      margin: 0 4%;
    }
  }
  .login-wrap {
    &.Gopay {
      background: url('../../../assets/images/gopay/gopay-2-mobile-bg.png') no-repeat center/cover;
    }
    &.gopay {
      background: url('../../../assets/images/gopay/gopay-3-mobile-bg.png') no-repeat center/cover;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/login-gopay/index.vue